// @flow
import i18n from "i18next";
import k from "src/i18n/keys";
import React from "react";
import { useSelector } from "react-redux";

import * as notifications from "src/constants/notifications";
import { getCurrentUserId } from "src/reducers";

import GenericNotification from "./Notification/Generic";

type Props = {
  message: any,
  first?: boolean,
  isFile?: boolean,
  isCurrentUser?: boolean,
};

const Deleted = ({
  message,
  first,
  isFile = false,
  isCurrentUser = false,
}: Props) => {
  const currentUser = useSelector(({ app }) => getCurrentUserId(app));
  const { deletedBy, deletedAt, action } = message;

  return (
    <GenericNotification
      message={message}
      isCurrentUser={currentUser === deletedBy || isCurrentUser}
      first={first}
      // $FlowFixMe - Flow does not support optional chaining
      timestamp={deletedAt?.toDate()?.toISOString()}
    >
      <i>
        {i18n.t(k.DELETED_A)}{" "}
        {action === notifications.FILE_ADD || isFile ? "file" : "message"}
        {i18n.t(k._9)}
      </i>
    </GenericNotification>
  );
};

export default Deleted;
